import {Component, Inject, OnInit} from '@angular/core';
import {AppService} from "../../app.service";
import {EntityService} from "../../_core/entity.service";
import {DialogsService} from "../../_services/dialogs.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import * as _ from "lodash";

@Component({
    selector: 'app-history-dialog',
    templateUrl: './history-dialog.component.html',
    styleUrl: './history-dialog.component.scss',
    standalone: false
})
export class HistoryDialogComponent implements OnInit {
	parametersObservable: any;
	sites: any = [];
	groupedSites = [];
	loaded: boolean = false;
	fromState:any = ['/profile/my-profile'];
	constructor(

		public appService: AppService,
		private entityService: EntityService,
		private dialogsService: DialogsService,
		public dialogRef: MatDialogRef<HistoryDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) { }

	ngOnInit() {
		this.appService.startBlock();
		this.onload();
	}

	onload() {
		this.entityService.getUserHistory().then(response => {
			if (this.loaded) return;
			this.loaded = true;
			this.sites = response;

			let that = this;
			let groupedSites = _.groupBy(response, o => { return o.organization });
			_.each(groupedSites, (val: any, key) => {
				that.groupedSites.push({ name: val[0].name, sites: val });
			})
		}).catch().then(o => {
			this.appService.stopBlock();
		})
	}


	historyClick(site, ev) {
		this.dialogsService.toggleActionFrame('bill', site, ev);
		return;
		this.dialogsService.openBillDialog(site);

	}
}


